import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: ReactNode;
  subtitle?: string;
  align?: "center" | "left";
  variant?: "light" | "dark";
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  variant = "light",
}: SectionHeadingProps) {
  const isDark = variant === "dark";
  return (
    <div
      className={`flex flex-col ${
        align === "center" ? "text-center items-center mx-auto max-w-2xl mb-14" : "text-left items-start max-w-2xl"
      }`}
    >
      <span
        className={`font-heading font-bold text-xs uppercase tracking-[0.25em] mb-4 ${
          isDark ? "text-primary-400" : "text-primary-600"
        }`}
      >
        {eyebrow}
      </span>
      <h2
        className={`font-heading text-3xl md:text-5xl font-extrabold leading-tight ${
          isDark ? "text-background-50" : "text-foreground-900"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-5 text-base md:text-lg leading-relaxed ${
            isDark ? "text-background-50/70" : "text-foreground-500"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}